(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bridal-enquiry-form"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-not-confirmed]').forEach(function (box) {
    var target = document.querySelector(box.getAttribute('data-not-confirmed'));
    if (!target) return;
    var wasRequired = target.required;
    box.addEventListener('change', function () {
      target.disabled = box.checked;
      target.required = wasRequired && !box.checked;
      if (box.checked) target.value = '';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bridal-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bridal-gallery')) {
    customElements.define(
      'bridal-gallery',
      class BridalGallery extends HTMLElement {
        connectedCallback() {
          this.triggers = Array.from(this.querySelectorAll('.bridal-gallery__trigger'));
          this.dialog = this.querySelector('.bridal-gallery__lightbox');
          this.fullImage = this.querySelector('.bridal-gallery__full');
          this.fullCaption = this.querySelector('.bridal-gallery__full-caption');
          this.counter = this.querySelector('.bridal-gallery__counter');

          // Marquee rows repeat each photo; the lightbox steps through each one once.
          const seen = new Map();
          this.triggers.forEach((trigger) => {
            if (!seen.has(trigger.dataset.index)) seen.set(trigger.dataset.index, trigger);
          });
          this.items = Array.from(seen.values()).sort((a, b) => a.dataset.index - b.dataset.index);
          this.current = 0;

          this.triggers.forEach((trigger) => {
            trigger.addEventListener('click', () => {
              this.lastTrigger = trigger;
              this.open(this.items.findIndex((item) => item.dataset.index === trigger.dataset.index));
            });
          });

          this.dialog.addEventListener('click', (event) => {
            const step = event.target.closest('[data-step]');
            if (step) return this.show(this.current + Number(step.dataset.step));
            if (event.target.closest('[data-close]') || event.target === this.dialog) this.dialog.close();
          });

          this.dialog.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowRight') this.show(this.current + 1);
            if (event.key === 'ArrowLeft') this.show(this.current - 1);
          });

          this.dialog.addEventListener('close', () => {
            document.documentElement.style.overflow = '';
            this.lastTrigger?.focus({ preventScroll: true });
          });

          this.setupReveal();
        }

        open(index) {
          this.show(index);
          document.documentElement.style.overflow = 'hidden';
          this.dialog.showModal();
        }

        show(index) {
          const total = this.items.length;
          if (!total) return;
          this.current = (index + total) % total;
          const trigger = this.items[this.current];
          const thumb = trigger.querySelector('img');

          this.fullImage.width = trigger.dataset.width;
          this.fullImage.height = trigger.dataset.height;
          this.fullImage.src = trigger.dataset.full;
          this.fullImage.alt = thumb ? thumb.alt : '';
          this.fullCaption.textContent = trigger.dataset.caption || '';
          this.fullCaption.hidden = !trigger.dataset.caption;
          this.counter.textContent = `${this.current + 1} / ${total}`;
        }

        setupReveal() {
          if (window.Shopify?.designMode) return;
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          if (!('IntersectionObserver' in window)) return;
          if (!this.querySelector('.bridal-gallery__grid')) return;

          this.classList.add('is-animated');
          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
              });
            },
            { rootMargin: '0px 0px -10% 0px' }
          );
          this.querySelectorAll('.bridal-gallery__item').forEach((item) => observer.observe(item));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.contact-form__form').forEach(function (form) {
    var select = form.querySelector('[data-enquiry-type]');
    var bridalBlock = form.querySelector('[data-bridal-fields]');
    var message = form.querySelector('[data-message-field]');
    if (!select || !bridalBlock) return;

    function sync() {
      var isBridal = select.value === 'Bridal enquiry';
      bridalBlock.classList.toggle('contact-form__bridal--hidden', !isBridal);
      bridalBlock.querySelectorAll('[data-bridal-required]').forEach(function (el) {
        el.required = isBridal && !el.disabled;
      });
      if (message) message.required = !isBridal;
    }

    form.querySelectorAll('[data-not-confirmed]').forEach(function (box) {
      var target = form.querySelector(box.getAttribute('data-not-confirmed'));
      if (!target) return;
      box.addEventListener('change', function () {
        target.disabled = box.checked;
        if (box.checked) target.value = '';
        sync();
      });
    });

    select.addEventListener('change', sync);
    sync();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const header = document.querySelector('[data-header]');
  const menuToggle = header.querySelector('[data-menu-toggle]');
  const menuClose = header.querySelector('[data-menu-close]');
  const mobileNav = header.querySelector('[data-mobile-nav]');

  menuToggle.addEventListener('click', () => mobileNav.showModal());
  menuClose.addEventListener('click', () => mobileNav.close());
  mobileNav.addEventListener('click', (e) => {
    if (e.target === mobileNav) mobileNav.close();
  });

  const headerSection = header.closest('.shopify-section');
  const smartSticky = header.dataset.sticky === 'smart';

  // Expose the header's live height so other sticky elements can sit below it
  const setHeaderHeight = () => {
    document.documentElement.style.setProperty('--header-height', `${headerSection.offsetHeight}px`);
  };
  new ResizeObserver(setHeaderHeight).observe(headerSection);
  setHeaderHeight();

  let lastY = window.scrollY;
  let ticking = false;

  const updateHeader = () => {
    const y = window.scrollY;
    headerSection.classList.toggle('is-scrolled', y > 24);

    if (smartSticky) {
      const scrollingDown = y > lastY;
      const pastHeader = y > header.offsetHeight * 2;
      if (Math.abs(y - lastY) > 6) {
        headerSection.classList.toggle('is-hidden', scrollingDown && pastHeader && !mobileNav.open);
      }
    }

    lastY = y;
    ticking = false;
  };

  window.addEventListener(
    'scroll',
    () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(updateHeader);
    },
    { passive: true }
  );
  updateHeader();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-hero-slideshow]');
    roots.forEach(function (root) {
      var slides = root.querySelectorAll('[data-hero-slide]');
      var dots = root.querySelectorAll('[data-hero-dot]');
      if (slides.length < 2) return;

      var current = 0;
      var interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;
      var autoplay = root.getAttribute('data-autoplay') === 'true';
      var timer = null;

      function go(index) {
        slides[current].classList.remove('is-active');
        if (dots[current]) dots[current].classList.remove('is-active');
        current = (index + slides.length) % slides.length;
        slides[current].classList.add('is-active');
        if (dots[current]) dots[current].classList.add('is-active');
      }

      function next() { go(current + 1); }

      function start() {
        if (!autoplay) return;
        stop();
        timer = window.setInterval(next, interval);
      }

      function stop() {
        if (timer) window.clearInterval(timer);
        timer = null;
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var target = parseInt(dot.getAttribute('data-slide-index'), 10);
          go(target);
          start();
        });
      });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);

      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-iwt-dreamy]');
    roots.forEach(function (root) {
      var slides = root.querySelectorAll('.iwt__slide');
      if (slides.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var current = 0;
      var interval = Math.max(parseInt(root.getAttribute('data-interval'), 10) || 6000, 4000);
      var timer = null;
      var inView = false;

      root.style.setProperty('--iwt-drift', interval + 2400 + 'ms');
      slides.forEach(function (slide) {
        var img = slide.querySelector('img');
        if (img) img.loading = 'eager';
      });

      function next() {
        var leaving = slides[current];
        current = (current + 1) % slides.length;
        leaving.classList.remove('is-active');
        leaving.classList.add('is-leaving');
        slides[current].classList.add('is-active');
        root.classList.add('is-dreaming');
        window.setTimeout(function () { root.classList.remove('is-dreaming'); }, 1200);
        window.setTimeout(function () { leaving.classList.remove('is-leaving'); }, 3200);
      }

      // The gallery has more to look at, so it lingers a little longer.
      function hold() {
        return slides[current].classList.contains('iwt__slide--gallery') ? interval * 1.5 : interval;
      }

      function start() {
        if (timer || !inView || document.hidden) return;
        timer = window.setTimeout(function () {
          timer = null;
          next();
          start();
        }, hold());
      }

      function stop() {
        window.clearTimeout(timer);
        timer = null;
      }

      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        inView ? start() : stop();
      }).observe(root);

      document.addEventListener('visibilitychange', function () {
        document.hidden ? stop() : start();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["split-service-promo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.getElementById('split-service-promo-{{ section.id }}');
    if (!section || !section.classList.contains('split-service-promo--animate')) return;
    var panels = section.querySelectorAll('.split-service-promo__panel');
    if (!panels.length || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.18 }
    );
    panels.forEach(function (panel, index) {
      panel.style.transitionDelay = (index * 90) + 'ms';
      observer.observe(panel);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var roots = document.querySelectorAll('[data-tabbed-gallery]');
      roots.forEach(function (root) {
        if (root.dataset.tabbedGalleryReady) return;
        root.dataset.tabbedGalleryReady = 'true';

        var tabs = root.querySelectorAll('[data-gallery-tab]');
        var panels = root.querySelectorAll('[data-gallery-panel]');
        if (!tabs.length) return;

        function activate(handle) {
          var found = false;
          panels.forEach(function (panel) {
            var match = panel.getAttribute('data-gallery-panel') === handle;
            panel.classList.toggle('is-active', match);
            if (match) {
              panel.removeAttribute('hidden');
              found = true;
            } else {
              panel.setAttribute('hidden', '');
            }
          });
          tabs.forEach(function (tab) {
            var match = tab.getAttribute('data-gallery-tab') === handle;
            tab.classList.toggle('is-active', match);
            tab.setAttribute('aria-selected', match ? 'true' : 'false');
          });
          return found;
        }

        tabs.forEach(function (tab) {
          tab.addEventListener('click', function () {
            activate(tab.getAttribute('data-gallery-tab'));
          });
        });

        // Deep link: /pages/bridal-gallery#hair opens the "Hair" tab.
        var hash = window.location.hash.replace('#', '');
        if (hash) activate(hash);
      });
    }

    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-rotator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-testimonial-rotator]');
    roots.forEach(function (root) {
      var slides = root.querySelectorAll('[data-rotator-slide]');
      var dots = root.querySelectorAll('[data-rotator-dot]');
      if (slides.length < 2) return;

      var current = 0;
      var interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var timer = null;

      function go(index) {
        slides[current].classList.remove('is-active');
        if (dots[current]) dots[current].classList.remove('is-active');
        current = (index + slides.length) % slides.length;
        slides[current].classList.add('is-active');
        if (dots[current]) dots[current].classList.add('is-active');
      }

      function start() {
        if (reduceMotion) return;
        stop();
        timer = window.setInterval(function () { go(current + 1); }, interval);
      }

      function stop() {
        if (timer) window.clearInterval(timer);
        timer = null;
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          go(parseInt(dot.getAttribute('data-slide-index'), 10));
          start();
        });
      });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);

      start();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
